<h2 mat-dialog-title>Load Form</h2>
 <form #dialogForm="ngForm" class="load-form">
<mat-dialog-content>
<div class="dialog-content-container">
 
    @if (!isLoading && !hasLoaded) {

      <app-text-input
          [label]="'Please enter your email'" 
          shortLabel="Email"
          [control]="loadForm.controls.email"
      ></app-text-input>

      <app-password-input
          [label]="'Please enter your password'" 
          shortLabel="Password"
          [control]="loadForm.controls.password"
          type="password"
      ></app-password-input>
       
    }

    @if (hasError) {
      <mat-error>
        We were unable to load a form for these credentials.
      </mat-error>
    }

    @if (hasLoaded) {
      <p>You have {{ getDaysRemaining() }} days remaining to submit this assessment. Click Continue to proceed</p>
    }

    @if (isLoading) {
      <div class="loading-container">
        <mat-spinner diameter="60"></mat-spinner>
       </div>
    }
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isLoading && !hasLoaded) {
    <button mat-flat-button type="button" class="cancel-button" (click)="close()">Cancel</button>
    <button 
      mat-flat-button 
      type="button" 
      color="primary" 
      (click)="load()" 
      [disabled]="dialogForm.invalid">
      Load
    </button>
  }
  
  @if (hasLoaded) {
    <button mat-flat-button type="button" (click)="continueClick()">Continue</button>
  }
</mat-dialog-actions>
</form>